import { render } from "./DeliveryMethodSelector.vue?vue&type=template&id=1f002455&scoped=true"
import script from "./DeliveryMethodSelector.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodSelector.vue?vue&type=script&lang=js"

import "./DeliveryMethodSelector.vue?vue&type=style&index=0&id=1f002455&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f002455"]])

export default __exports__